import { ConnectedOverlayPositionChange, FlexibleConnectedPositionStrategy, OverlayRef } from '@angular/cdk/overlay';
import { ElementRef } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { merge, Observable, Subject } from 'rxjs';
import { filter, take } from 'rxjs/operators';

import { PopoverConfig } from './popover-config';

/**
 * Reference to a popover opened via the Popover service.
 */
export class PopoverRef<T> {
  private readonly afterClosedSubject = new Subject();
  private readonly escapeEvents = this.overlayRef.keydownEvents().pipe(filter((event) => event.key === 'Escape'));
  private readonly clickOutsideEvents = this.overlayRef.outsidePointerEvents();
  private readonly navigationStartsEvents = this.router.events.pipe(
    filter((event) => event instanceof NavigationStart)
  );
  constructor(
    private readonly overlayRef: OverlayRef,
    private readonly positionStrategy: FlexibleConnectedPositionStrategy,
    public config: PopoverConfig<PopoverRef<T>>,
    private readonly router: Router
  ) {
    merge(this.escapeEvents, this.navigationStartsEvents, this.clickOutsideEvents)
      .pipe(take(1))
      .subscribe(() => {
        this.close();
      });
  }

  close(dialogResult?: unknown): void {
    this.afterClosedSubject.next(dialogResult);
    this.afterClosedSubject.complete();

    this.overlayRef.dispose();
  }

  afterClosed(): Observable<unknown> {
    return this.afterClosedSubject.asObservable();
  }

  positionChanges(): Observable<ConnectedOverlayPositionChange> {
    return this.positionStrategy.positionChanges;
  }

  updateAnchor(anchor: ElementRef | HTMLElement): void {
    this.positionStrategy.setOrigin(anchor);
    this.positionStrategy.apply();
  }
}
